import React from 'react'
import './Footer.css'
import github from '../../assets/github.png'
import instagram from '../../assets/instagram.png'
import linkedin from '../../assets/linkedin.png'
import logo from '../../assets/logo.png'
const Footer = () => {
  return (
    <div className='Footercontainer'>
        <hr />
        <div className='footer'>
            <div className='social_links'>
                <img src={github} alt='github' />
                <img src={instagram} alt='instagram' />
                <img src={linkedin} alt='linkedin' />
            </div>
            <div className='logo-f'>
                <img src={logo} alt='logo' />
            </div>
        </div>
        <div className='blur blur-footer1'></div>
        <div className='blur blur-footer2'></div>
    </div>
  )
}

export default Footer